import LogoImage from '../Assets/Images/spjainDetailed.png';
export const KEY_AZURE_TOKEN = 'azure_token';
export const KEY_ACCESS_TOKEN = 'access_token';
export const KEY_REFRESH_TOKEN = 'refresh_token';
export const KEY_CONFIG_URL = 'https://config-api.ken42.com/v1/configs/url';
export const REFRESH_URL = 'https://api-v2.ken42.com/sp-jain/stage/api/app/refreshToken';
export const REGEX = {
  NAME: /^[a-zA-Z]+$/,
  MOBILE: /^(\+\d{1,3}[- ]?)?\d{10}$/,
  PINCODE: /^[0-9]{6,6}$/,
  NUMBER: /[^0-9]/,
  ONLYNUMBER: /^[0-9]*$/,
  ALPHA_WITH_SPACE: /^[a-zA-Z\s]+$/,
  ALPHANUMERIC_WITH_SPACE: /^[a-zA-Z0-9\s]+$/,
  NUMBERWITHDECIMAL: /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/,
  ANNUALINCOME: /^\d*(\.\d+)?$/,
  DIGITS_ONLY_UPTO_100: /^\-?(([0-9]\d?|0\d{1,2})((\.)\d{0,2})?|100((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_10: /^\-?((0\d|\d)?((\.)\d{0,2})?|10((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_4: /^\-?((0[0-3]|[0-3])?((\.)\d{0,2})?|(4|04)((\.)0{1,2})?)$/,
  PERCENTAGE: /^100$/,
  CGPA: /^10$/,
  GRADE: /^[a-fA-FOoPp]$/,
  MIXED: /^[a-zA-Z0-9-./, ]*$/,
  PINCODE: /^[a-zA-Z0-9-./,]*$/,
  LASTNAME: /^[A-Za-z .,']*$/,
  MIXED_ADDRESS: /^[a-zA-Z0-9-.#/, ]*$/,
  PARENT_DOC: /^aadhaarParent/,
  PHONE_NUMBER: /^[0-9]*$/,
  AADHAAR: '^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$',
  ALPHA_SPECIAL: /^[a-zA-Z\s'’]+$/,
  PAN: /^[A-Z]{5}\d{4}[A-Z]$/,
  GRADE2: /^[A-D][1-9]?(\+{1,2})?$/,
  PAN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
  GST: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
  WEBSITE: /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
  EMAIL: /(?!.*\.com\.|.*\.in\.)(?!.*\s)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/,
  //   EMAIL:
  //     /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};

export const ROLES = { APPLICANT: 'APPLICANT', PARTNER: 'PARTNER' };
export const PERMISSIONS = {
  [ROLES.APPLICANT]: {
    APP_HOME: 'APP_HOME',
    APP_APPLICATIONS: 'APP_APPLICATIONS',
    APP_DOCUMENTS: 'APP_DOCUMENTS',
    APP_THANKYOU: 'APP_THANKYOU',
    APP_FEEPAYEMENTS: 'APP_FEEPAYEMENTS',
    APP_COURSES: 'APP_COURSES',
    APP_ONBOARDING: 'APP_ONBOARDING',
    APP_FEEDETAILS: 'APP_FEEDETAILS',
    APP_OFFERLETTERDETAILED: 'APP_OFFERLETTERDETAILED',
    APP_INTERVIEWSLOTS: 'APP_INTERVIEWSLOTS',
    APP_INTERVIEW: 'APP_INTERVIEW',
    APP_OFFERLETTER: 'APP_OFFERLETTER',
    APP_FEESTRUCTURE: 'APP_FEESTRUCTURE',
    APP_HDFC: 'APP_HDFC',
  },
  [ROLES.PARTNER]: {
    PAR_HOME: 'PAR_HOME',
    PAR_APPLICATIONS: 'PAR_APPLICATIONS',
  },
};
export const TABLET_BREAKPOINT = 'tablet';
export const SENTRY_DSN = 'https://8ef3f8ad3fc6dd73f36a32ed1e81228b@o4506744673861632.ingest.sentry.io/4506783279546368';
export const REACT_APP_ENVIRONMENT = 'Staging';
export const LOGO = LogoImage;
